import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GerarIssCacheService {

  cucTomador: string;
  idNota: string;
  tipoIss: string;
  PHPSESSID: string;
  constructor() { }
}
